/** @format */

const template = `
<div>
  <span>{{ctrl.periodText()}}</span>
</div>
`;
export default template;
